import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" };
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" };
const _hoisted_3 = { class: "d-flex justify-content-end align-items-center mb-4" };
const _hoisted_4 = { class: "me-2 fw-medium text-black" };
const _hoisted_5 = { class: "ms-3 d-flex gap-2" };
const _hoisted_6 = ["onClick", "title"];
const _hoisted_7 = { class: "row" };
const _hoisted_8 = { class: "col-md-12" };
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_10 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_11 = ["placeholder"];
const _hoisted_12 = { class: "col-md-12" };
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_14 = { class: "d-flex justify-content-between align-items-center mb-2" };
const _hoisted_15 = { class: "d-block text-black fw-semibold mb-0" };
const _hoisted_16 = ["disabled"];
const _hoisted_17 = {
    value: null,
    disabled: ""
};
const _hoisted_18 = ["value"];
const _hoisted_19 = { class: "col-md-12" };
const _hoisted_20 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_21 = { class: "d-flex justify-content-between align-items-center mb-3" };
const _hoisted_22 = { class: "d-block text-black fw-semibold mb-0" };
const _hoisted_23 = {
    key: 0,
    class: "badge bg-success"
};
const _hoisted_24 = {
    key: 1,
    class: "badge bg-warning"
};
const _hoisted_25 = { class: "card border-0 shadow-sm mb-3" };
const _hoisted_26 = { class: "card-body" };
const _hoisted_27 = { class: "row" };
const _hoisted_28 = { class: "col-md-12 mb-3" };
const _hoisted_29 = { class: "d-block text-black fw-medium mb-2" };
const _hoisted_30 = ["placeholder"];
const _hoisted_31 = { class: "col-md-6" };
const _hoisted_32 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_33 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_34 = ["placeholder"];
const _hoisted_35 = { class: "form-text text-muted" };
const _hoisted_36 = { class: "col-md-6" };
const _hoisted_37 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_38 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_39 = ["src"];
const _hoisted_40 = ["placeholder"];
const _hoisted_41 = ["required"];
const _hoisted_42 = { class: "col-md-6" };
const _hoisted_43 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_44 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_45 = {
    class: "btn btn-outline-warning",
    type: "button",
    "data-bs-toggle": "modal",
    "data-bs-target": "#contentModalScrollable_supplementSize"
};
const _hoisted_46 = { class: "mt-10" };
const _hoisted_47 = { key: 0 };
const _hoisted_48 = { class: "table-responsive shadow-sm rounded-2" };
const _hoisted_49 = { class: "table align-middle mb-0 variation-table" };
const _hoisted_50 = { class: "text-uppercase fw-semibold small text-muted" };
const _hoisted_51 = { class: "text-uppercase fw-semibold small text-muted" };
const _hoisted_52 = { class: "fw-semibold text-black" };
const _hoisted_53 = { class: "fw-semibold text-success" };
const _hoisted_54 = {
    key: 1,
    class: "text-warning small fw-medium fst-italic d-inline-flex align-items-center"
};
const _hoisted_55 = { class: "col-md-12" };
const _hoisted_56 = {
    key: 0,
    class: "d-flex align-items-center justify-content-between"
};
const _hoisted_57 = ["disabled"];
const _hoisted_58 = { class: "position-relative" };
const _hoisted_59 = {
    class: "modal fade",
    id: "contentModalScrollable_supplementTypes",
    tabindex: "-1",
    "aria-hidden": "true"
};
const _hoisted_60 = { class: "modal-dialog modal-dialog-scrollable modal-lg" };
const _hoisted_61 = { class: "modal-content flex-column justify-content-center" };
const _hoisted_62 = { class: "modal-header" };
const _hoisted_63 = { class: "modal-title fs-5" };
const _hoisted_64 = { class: "modal-body" };
const _hoisted_65 = {
    key: 0,
    class: "text-center py-4"
};
const _hoisted_66 = {
    key: 1,
    class: "text-center py-4"
};
const _hoisted_67 = { class: "text-muted" };
const _hoisted_68 = { key: 2 };
const _hoisted_69 = { class: "table-responsive" };
const _hoisted_70 = { class: "table align-middle mb-0" };
const _hoisted_71 = { class: "bg-success text-white" };
const _hoisted_72 = { class: "text-uppercase fw-medium shadow-none text-white fs-13 pt-0" };
const _hoisted_73 = { class: "text-uppercase fw-medium shadow-none text-white fs-13 pt-0" };
const _hoisted_74 = { class: "text-uppercase fw-medium shadow-none text-white fs-13 pt-0 text-end" };
const _hoisted_75 = { class: "fw-semibold text-black" };
const _hoisted_76 = ["onUpdate:modelValue"];
const _hoisted_77 = { class: "text-end" };
const _hoisted_78 = ["onClick", "disabled"];
const _hoisted_79 = { class: "modal-footer" };
const _hoisted_80 = {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
};
const _hoisted_81 = {
    class: "modal fade",
    id: "contentModalScrollable_supplementSize",
    tabindex: "-1",
    "aria-hidden": "true"
};
const _hoisted_82 = { class: "modal-dialog modal-dialog-scrollable modal-lg" };
const _hoisted_83 = { class: "modal-content flex-column justify-content-center" };
const _hoisted_84 = { class: "modal-header" };
const _hoisted_85 = { class: "modal-title fs-5" };
const _hoisted_86 = { class: "modal-body" };
const _hoisted_87 = { class: "flex-column" };
const _hoisted_88 = { class: "row" };
const _hoisted_89 = { class: "col-md-6" };
const _hoisted_90 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_91 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_92 = ["placeholder", "required"];
const _hoisted_93 = { class: "col-md-6" };
const _hoisted_94 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_95 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_96 = ["placeholder", "required"];
const _hoisted_97 = { class: "col-md-12" };
const _hoisted_98 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_99 = ["disabled"];
const _hoisted_100 = { class: "table-responsive flex justify-content-center items-center" };
const _hoisted_101 = { class: "table text-nowrap align-middle mb-0" };
const _hoisted_102 = { class: "bg-success text-white" };
const _hoisted_103 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_104 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_105 = { key: 0 };
const _hoisted_106 = { class: "shadow-none lh-1 fw-bold ps-0" };
const _hoisted_107 = { class: "text-decoration-none text-black-emphasis" };
const _hoisted_108 = { class: "shadow-none lh-1 fw-medium" };
const _hoisted_109 = { class: "badge text-outline-danger" };
const _hoisted_110 = { class: "shadow-none lh-1 fw-medium text-body-tertiary" };
const _hoisted_111 = ["onClick"];
const _hoisted_112 = { key: 1 };
const _hoisted_113 = { class: "d-flex justify-content-center align-items-center mt-8" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = _resolveComponent("v-select");
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    const _component_EmptyTable = _resolveComponent("EmptyTable");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.language')) + ":", 1),
                _createVNode(_component_v_select, {
                    modelValue: _ctx.selectedLanguage,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedLanguage) = $event)),
                    options: _ctx.availableLanguages,
                    label: "name",
                    reduce: (lang) => lang.code,
                    class: "language-selector",
                    style: { "min-width": "150px" }
                }, null, 8, ["modelValue", "options", "reduce"]),
                _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLanguages, (lang) => {
                        return (_openBlock(), _createElementBlock("span", {
                            key: lang.code,
                            class: _normalizeClass(["badge",
                                _ctx.isTranslationComplete(lang.code) ? 'bg-success' : 'bg-secondary'
                            ]),
                            style: { "cursor": "pointer" },
                            onClick: ($event) => (_ctx.selectedLanguage = lang.code),
                            title: _ctx.isTranslationComplete(lang.code)
                                ? `${lang.name} - ${_ctx.$t('supplement.complete')}`
                                : `${lang.name} - ${_ctx.$t('supplement.incomplete')}`
                        }, _toDisplayString(lang.code.toUpperCase()), 11, _hoisted_6));
                    }), 128))
                ])
            ]),
            _createElementVNode("form", {
                onSubmit: _cache[14] || (_cache[14] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.uploadLogo && _ctx.uploadLogo(...args)), ["prevent"]))
            }, [
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('common.name')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.supplementData.name) }]),
                                placeholder: _ctx.$t('supplement.namePlaceholder'),
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.supplementData.name) = $event)),
                                onChange: _cache[2] || (_cache[2] = (event) => _ctx.handleInput(event, 'name')),
                                required: ""
                            }, null, 42, _hoisted_11), [
                                [_vModelText, _ctx.supplementData.name]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('supplement.type')) + " * ", 1),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm btn-outline-primary",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#contentModalScrollable_supplementTypes",
                                    onClick: _cache[3] || (_cache[3] =
                                        //@ts-ignore
                                        (...args) => (_ctx.loadSupplementTypes && _ctx.loadSupplementTypes(...args)))
                                }, [
                                    _cache[21] || (_cache[21] = _createElementVNode("i", { class: "fas fa-cog me-1" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('supplement.managePositions')), 1)
                                ])
                            ]),
                            _withDirectives(_createElementVNode("select", {
                                class: _normalizeClass(["form-select shadow-none fw-semibold rounded-0", { 'is-valid': _ctx.supplementData.supplementTypeId }]),
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.supplementData.supplementTypeId) = $event)),
                                onChange: _cache[5] || (_cache[5] = (event) => _ctx.handleInput(event, 'supplementTypeId')),
                                disabled: _ctx.supplementTypes.length === 0
                            }, [
                                _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.$t('supplement.selectType')), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedSupplementTypes, (type) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: type.id,
                                        value: type.id
                                    }, _toDisplayString(type.label), 9, _hoisted_18));
                                }), 128))
                            ], 42, _hoisted_16), [
                                [_vModelSelect, _ctx.supplementData.supplementTypeId]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('supplement.multilingualTranslations')) + " - " + _toDisplayString(_ctx.getCurrentLanguageName()), 1),
                                (_ctx.isTranslationComplete(_ctx.selectedLanguage))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                                        _cache[22] || (_cache[22] = _createElementVNode("i", { class: "fas fa-check me-1" }, null, -1)),
                                        _createTextVNode(_toDisplayString(_ctx.$t('supplement.complete')), 1)
                                    ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                        _cache[23] || (_cache[23] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-1" }, null, -1)),
                                        _createTextVNode(_toDisplayString(_ctx.$t('supplement.incomplete')), 1)
                                    ]))
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, [
                                    _createElementVNode("div", _hoisted_27, [
                                        _createElementVNode("div", _hoisted_28, [
                                            _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('common.name')) + " * ", 1),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control shadow-none rounded-0 text-black",
                                                placeholder: _ctx.$t('supplement.namePlaceholderLang', { lang: _ctx.getCurrentLanguageName() }),
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.currentTranslation.name) = $event)),
                                                onBlur: _cache[7] || (_cache[7] = ($event) => (_ctx.saveTranslation(_ctx.selectedLanguage)))
                                            }, null, 40, _hoisted_30), [
                                                [_vModelText, _ctx.currentTranslation.name]
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('supplement.supplementPosition')), 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: "form-control shadow-none rounded-0 text-black",
                                placeholder: _ctx.$t('supplement.supplementPositionPlaceholder'),
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.supplementData.position) = $event)),
                                onChange: _cache[9] || (_cache[9] = (event) => _ctx.handleInput(event, 'position')),
                                min: "0"
                            }, null, 40, _hoisted_34), [
                                [_vModelText, _ctx.supplementData.position]
                            ]),
                            _createElementVNode("small", _hoisted_35, _toDisplayString(_ctx.$t('supplement.supplementPositionHelp')), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t('supplement.icon')) + " * ", 1),
                            (_ctx.supplementData.imageUrl)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _ctx.supplementData.imageUrl,
                                    class: "rounded-circle me-8 mb-4",
                                    width: "45",
                                    height: "45",
                                    alt: "supplement"
                                }, null, 8, _hoisted_39))
                                : _createCommentVNode("", true),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control shadow-none rounded-0 text-black mb-10",
                                placeholder: _ctx.$t('supplement.imageUrlPlaceholder'),
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.supplementData.imageUrl) = $event)),
                                onChange: _cache[11] || (_cache[11] = (event) => _ctx.handleInput(event, 'imageUrl'))
                            }, null, 40, _hoisted_40), [
                                [_vModelText, _ctx.supplementData.imageUrl]
                            ]),
                            _createElementVNode("input", {
                                type: "file",
                                class: "form-control shadow-none rounded-0 text-black",
                                placeholder: "**************",
                                onChange: _cache[12] || (_cache[12] = (event) => _ctx.handleInput(event, 'file')),
                                required: _ctx.actionDetected === 'add' && !_ctx.supplementData.imageUrl
                            }, null, 40, _hoisted_41)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t('supplement.variationLabel')) + "* ", 1),
                            _createElementVNode("button", _hoisted_45, _toDisplayString(_ctx.actionDetected === "edit"
                                ? _ctx.$t('supplement.updateVariation')
                                : _ctx.$t('supplement.addVariation')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                            (_ctx.allVariationsSupplementSize.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                    _createElementVNode("div", _hoisted_48, [
                                        _createElementVNode("table", _hoisted_49, [
                                            _createElementVNode("thead", null, [
                                                _createElementVNode("tr", null, [
                                                    _createElementVNode("th", _hoisted_50, _toDisplayString(_ctx.$t('supplement.size')), 1),
                                                    _createElementVNode("th", _hoisted_51, _toDisplayString(_ctx.$t('common.price')), 1)
                                                ])
                                            ]),
                                            _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allVariationsSupplementSize, (variation, index) => {
                                                    return (_openBlock(), _createElementBlock("tr", {
                                                        key: `summary-${index}`
                                                    }, [
                                                        _createElementVNode("td", _hoisted_52, _toDisplayString(variation.size), 1),
                                                        _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.formatPrice(variation.price)), 1)
                                                    ]));
                                                }), 128))
                                            ])
                                        ])
                                    ])
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                    _cache[24] || (_cache[24] = _createElementVNode("i", { class: "flaticon-warning lh-1 me-5" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('supplement.noSizeAdded')), 1)
                                ]))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                        (_ctx.actionDetected)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                (_ctx.isLoading)
                                    ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
                                    : (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: _normalizeClass(["default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success", { 'opacity-50 cursor-not-allowed': !_ctx.isFormValid }]),
                                        type: "submit",
                                        disabled: !_ctx.isFormValid
                                    }, _toDisplayString(_ctx.actionDetected === "edit"
                                        ? _ctx.$t('common.update')
                                        : _ctx.$t('supplement.addSupplement')), 11, _hoisted_57)),
                                _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[13] || (_cache[13] =
                                        //@ts-ignore
                                        (...args) => (_ctx.goBack && _ctx.goBack(...args))),
                                    class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                                }, [
                                    _cache[25] || (_cache[25] = _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1)),
                                    _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.$t('common.cancel')), 1)
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ], 32)
        ]),
        _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("h1", _hoisted_63, _toDisplayString(_ctx.$t('supplement.manageTypePositions')), 1),
                        _cache[26] || (_cache[26] = _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_64, [
                        (_ctx.isLoadingTypes)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                _createVNode(_component_LoaderComponent)
                            ]))
                            : (_ctx.supplementTypes.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                    _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.$t('supplement.noTypesAvailable')), 1)
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                    _createElementVNode("div", _hoisted_69, [
                                        _createElementVNode("table", _hoisted_70, [
                                            _createElementVNode("thead", _hoisted_71, [
                                                _createElementVNode("tr", null, [
                                                    _createElementVNode("th", _hoisted_72, _toDisplayString(_ctx.$t('supplement.type')), 1),
                                                    _createElementVNode("th", _hoisted_73, _toDisplayString(_ctx.$t('supplement.position')), 1),
                                                    _createElementVNode("th", _hoisted_74, _toDisplayString(_ctx.$t('common.actions')), 1)
                                                ])
                                            ]),
                                            _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedSupplementTypes, (type) => {
                                                    return (_openBlock(), _createElementBlock("tr", {
                                                        key: type.type
                                                    }, [
                                                        _createElementVNode("td", _hoisted_75, _toDisplayString(type.type), 1),
                                                        _createElementVNode("td", null, [
                                                            _withDirectives(_createElementVNode("input", {
                                                                type: "number",
                                                                class: "form-control shadow-none rounded-0 text-black",
                                                                "onUpdate:modelValue": ($event) => ((type.position) = $event),
                                                                min: "1",
                                                                style: { "width": "100px" }
                                                            }, null, 8, _hoisted_76), [
                                                                [
                                                                    _vModelText,
                                                                    type.position,
                                                                    void 0,
                                                                    { number: true }
                                                                ]
                                                            ])
                                                        ]),
                                                        _createElementVNode("td", _hoisted_77, [
                                                            _createElementVNode("button", {
                                                                onClick: ($event) => (_ctx.updateTypePosition(type)),
                                                                class: "btn btn-sm btn-primary",
                                                                type: "button",
                                                                disabled: _ctx.isUpdatingPosition
                                                            }, [
                                                                _cache[27] || (_cache[27] = _createElementVNode("i", { class: "fas fa-save me-1" }, null, -1)),
                                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.save')), 1)
                                                            ], 8, _hoisted_78)
                                                        ])
                                                    ]));
                                                }), 128))
                                            ])
                                        ])
                                    ])
                                ]))
                    ]),
                    _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("button", _hoisted_80, _toDisplayString(_ctx.$t('common.close')), 1)
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_81, [
            _createElementVNode("div", _hoisted_82, [
                _createElementVNode("div", _hoisted_83, [
                    _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("h1", _hoisted_85, _toDisplayString(_ctx.$t('supplement.specifySizes')), 1),
                        _cache[28] || (_cache[28] = _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("div", _hoisted_88, [
                                _createElementVNode("div", _hoisted_89, [
                                    _createElementVNode("div", _hoisted_90, [
                                        _createElementVNode("label", _hoisted_91, _toDisplayString(_ctx.$t('supplement.size')) + "* ", 1),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control shadow-none rounded-0 text-black",
                                            placeholder: _ctx.$t('supplement.sizePlaceholder'),
                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.supplementSizeDefine.size) = $event)),
                                            onChange: _cache[16] || (_cache[16] = (event) => _ctx.handleInput(event, 'size')),
                                            required: _ctx.actionDetected === 'add'
                                        }, null, 40, _hoisted_92), [
                                            [_vModelText, _ctx.supplementSizeDefine.size]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_93, [
                                    _createElementVNode("div", _hoisted_94, [
                                        _createElementVNode("label", _hoisted_95, _toDisplayString(_ctx.$t('common.price')) + "* ", 1),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control shadow-none rounded-0 text-black",
                                            placeholder: _ctx.$t('supplement.pricePlaceholder'),
                                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.supplementSizeDefine.price) = $event)),
                                            onChange: _cache[18] || (_cache[18] = (event) => _ctx.handleInput(event, 'price')),
                                            required: _ctx.actionDetected === 'add'
                                        }, null, 40, _hoisted_96), [
                                            [_vModelText, _ctx.supplementSizeDefine.price]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_97, [
                                    _createElementVNode("div", _hoisted_98, [
                                        _createElementVNode("button", {
                                            onClick: _cache[19] || (_cache[19] =
                                                //@ts-ignore
                                                (...args) => (_ctx.addSizeVariation && _ctx.addSizeVariation(...args))),
                                            class: _normalizeClass(["btn btn-warning btn-sm", {
                                                    'opacity-50 cursor-not-allowed': !_ctx.isFormValidVariation,
                                                }]),
                                            type: "button",
                                            disabled: !_ctx.isFormValidVariation
                                        }, _toDisplayString(_ctx.$t('common.add')), 11, _hoisted_99)
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_100, [
                                _createElementVNode("table", _hoisted_101, [
                                    _createElementVNode("thead", _hoisted_102, [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", _hoisted_103, _toDisplayString(_ctx.$t('supplement.size').toUpperCase()), 1),
                                            _createElementVNode("th", _hoisted_104, _toDisplayString(_ctx.$t('common.price').toUpperCase()), 1)
                                        ])
                                    ]),
                                    (_ctx.allVariationsSupplementSize &&
                                        _ctx.allVariationsSupplementSize.length > 0)
                                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_105, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allVariationsSupplementSize, (variation, index) => {
                                                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                                    _createElementVNode("th", _hoisted_106, [
                                                        _createElementVNode("span", _hoisted_107, _toDisplayString(variation.size), 1)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_108, [
                                                        _createElementVNode("span", _hoisted_109, _toDisplayString(variation.price) + " CHF", 1)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_110, [
                                                        _createElementVNode("button", {
                                                            onClick: ($event) => (_ctx.removeSizeVariation(variation)),
                                                            class: "btn btn-danger btn-sm",
                                                            type: "button"
                                                        }, _toDisplayString(_ctx.$t('supplement.remove')), 9, _hoisted_111)
                                                    ])
                                                ]));
                                            }), 128))
                                        ]))
                                        : (_openBlock(), _createElementBlock("tbody", _hoisted_112, [
                                            _createElementVNode("tr", null, [
                                                _createVNode(_component_EmptyTable, {
                                                    message: _ctx.$t('supplement.noSizeAddedModal'),
                                                    colspan: 8,
                                                    textClass: "text-muted"
                                                }, null, 8, ["message"])
                                            ])
                                        ]))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_113, [
                                _createElementVNode("button", {
                                    onClick: _cache[20] || (_cache[20] = ($event) => (_ctx.updateVariationProduct(_ctx.supplementResponse?.id))),
                                    class: "btn btn-primary btn-sm",
                                    type: "button",
                                    "data-bs-dismiss": "modal",
                                    "aria-label": "Close"
                                }, _toDisplayString(_ctx.$t('common.confirm')), 1)
                            ])
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
